<template>
  <div v-if="warningBanners?.length > 0">
    <pcqm-dashboard-warning
      v-for="warningBanner in warningBanners"
      :key="warningBanner"
      :warning-banner="warningBanner"
    />
  </div>
</template>

<script>
import PcqmDashboardWarning from '@/components/generic/presentational/molecules/pcqmDashboardWarning/PcqmDashboardWarning.vue'
import { mapGetters } from 'vuex'

export default {
  components: { PcqmDashboardWarning },
  computed: {
    ...mapGetters({ warningBanners: 'warningBanner/get' }),
  },
}
</script>
<style lang="scss" scoped></style>
